import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { generateGeneralWhatsAppLink } from '../data/products';

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '32px',
        right: '32px',
        zIndex: 9990,
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}
    >
      {/* Tooltip */}
      {hovered && (
        <div
          style={{
            background: 'rgba(7, 19, 31, 0.92)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(37, 211, 102, 0.4)',
            color: '#ffffff',
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: 700,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
            whiteSpace: 'nowrap'
          }}
        >
          Chat with <span className="brand-name">RAYYAN DENIM</span>
        </div>
      )}

      {/* Floating Button */}
      <a
        href={generateGeneralWhatsAppLink("WhatsApp Widget")}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Chat on WhatsApp"
        style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          backgroundColor: '#25d366',
          color: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 8px 24px rgba(37, 211, 102, 0.4)',
          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          textDecoration: 'none'
        }}
      >
        <MessageSquare size={26} />
      </a>
    </div>
  );
};

export default WhatsAppButton;
